import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ToolInfoBoxService {

  public isInfoBoxActive: boolean = false;

  constructor() {

  }

}
